module.exports = __webpack_public_path__ + "img/medici-thumbnail1.5f6f3e9b.png";